import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { approveUsersService, fetchAdminProfilesService } from "../../services";
import { HttpApiClient } from "../../axios/axiosInstance";

const initialState = {
  loading: false,
  adminProfiles: [],
  error: null,
  totalProfiles: 0,
};

export const fetchAdminProfiles = createAsyncThunk(
  "admin/fetchAdminProfiles",
  async (request) => {
    const response = await HttpApiClient.post(
      fetchAdminProfilesService,
      request
    );
    return response.data.data;
  }
);

export const approveUsers = createAsyncThunk(
  "admin/approveUsers",
  async (request) => {
    const response = await HttpApiClient.post(approveUsersService, request);
    return response.data;
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminProfiles.fulfilled, (state, action) => {
        state.adminProfiles = action.payload;
        state.totalProfiles = action.payload.total;
        state.loading = false;
      })
      .addCase(fetchAdminProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminProfiles.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default adminSlice.reducer;
